export function applyCurrentTimeIfToday(selectedDate) {
  if (!selectedDate) return selectedDate;

  const now = new Date();
  const sameCalendarDay =
    selectedDate.getFullYear() === now.getFullYear() &&
    selectedDate.getMonth() === now.getMonth() &&
    selectedDate.getDate() === now.getDate();

  if (!sameCalendarDay) return selectedDate;

  const looksLikeCalendarDayPickOnly =
    selectedDate.getHours() === 0 &&
    selectedDate.getMinutes() === 0 &&
    selectedDate.getSeconds() === 0 &&
    selectedDate.getMilliseconds() === 0;

  if (!looksLikeCalendarDayPickOnly) {
    return selectedDate;
  }

  const out = new Date(selectedDate);
  out.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds(),
  );
  return out;
}
